import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { Box, Breadcrumbs, Typography } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {
  HOME_ROUTE,
  TICKET_SUCCESSFUL,
  TICKET_ERROR,
  TICKET_SUCCESSFUL_INNER_FORMS,
  RPHONE,
  DEBIT,
  STORE,
  PROVIDERS,
  MOTIVE_MESSAGE_MOBILE,
} from '../../../constants/routes';
import { simple } from '../../../config/paths';
import { useBreadCrumsStyles } from './styles';
import { setIdType } from '../../../redux/slices/BreadcrumbsSlice';
import { resetPost } from '../../../redux/slices/ValidationProductSlice';

const BreadCrumbs = ({ ...props }) => {
  const { mobile } = props;
  const classes = useBreadCrumsStyles({ mobile });
  const history = useHistory();
  const location = useLocation();
  const { title, subtitle } = useSelector((state) => state.breadcrumbsSlice);
  const isMobile = useMediaQuery({ maxWidth: 1200 });
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  const issueId = params.get('issueId');

  const goToHome = (level) => {
    history.push(HOME_ROUTE);
    dispatch(resetPost());

    if (level === 'openMotives') dispatch(setIdType(''));
  };

  const catchTitleTypesMobile = () => {
    const issueIds = Object.assign(
      {},
      {
        6: 'Tarjeta Ripley',
        9: 'Gift Cards',
      },
    );

    return Object.prototype.hasOwnProperty.call(issueIds, issueId)
      ? issueIds[issueId]
      : undefined;
  };

  const cyTitle = title.replace(/ /g, '');
  const cySubtitle = subtitle.replace(/ /g, '');

  return (
    <React.Fragment>
      <Box>
        {location.pathname !== TICKET_SUCCESSFUL &&
          location.pathname !== TICKET_ERROR &&
          location.pathname !== TICKET_SUCCESSFUL_INNER_FORMS &&
          location.pathname !== RPHONE &&
          location.pathname !== DEBIT &&
          location.pathname !== STORE &&
          location.pathname !== PROVIDERS && (
            <Breadcrumbs
              className={classes.breadCrumbs}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="inherit" />}
            >
              <Typography
                className={classes.otherBreadcrumb}
                onClick={() => window.open(simple, '_blank')}
              >
                Ripley
              </Typography>
              <Typography
                onClick={() => goToHome('openMotives')}
                className={
                  location.pathname === HOME_ROUTE
                    ? classes.currentBreadcrumb
                    : classes.otherBreadcrumb
                }
              >
                Contacto
              </Typography>
              {!isMobile && location.pathname !== HOME_ROUTE && (
                <Typography
                  data-cy={`id${cyTitle}`}
                  onClick={goToHome}
                  className={classes.otherBreadcrumb}
                >
                  {title}
                </Typography>
              )}
              {location.pathname !== HOME_ROUTE &&
                location.pathname !== MOTIVE_MESSAGE_MOBILE && (
                  <Typography
                    data-cy={`id${cySubtitle}`}
                    className={classes.currentBreadcrumb}
                  >
                    {subtitle}
                  </Typography>
                )}
              {location.pathname === MOTIVE_MESSAGE_MOBILE && (
                <Typography
                  data-cy={`id${cySubtitle}`}
                  className={classes.currentBreadcrumb}
                >
                  {catchTitleTypesMobile()}
                </Typography>
              )}
            </Breadcrumbs>
          )}
      </Box>
    </React.Fragment>
  );
};

BreadCrumbs.propTypes = {
  mobile: PropTypes.bool,
};

export default BreadCrumbs;
